import { createSelector } from '@ngrx/store'
import { AppState } from '../app.state'
import { FeatureSPState } from './feature-sp.state'

export const getFeatureSP = (state: AppState) => state.featureSearchProjects

export const selectSPSearchOpen = createSelector(getFeatureSP, (state: FeatureSPState) => state.isSearchOpen)

export const selectIsAdvancedSPSearch = createSelector(getFeatureSP, (state: FeatureSPState) => state.isAdvancedSearch)

export const selectSPSearchDone = createSelector(getFeatureSP, (state: FeatureSPState) => state.isSearchDone)

export const selectIsLoadingSearch = createSelector(getFeatureSP, (state: FeatureSPState) => state.isLoading)

export const selectSearchResult = createSelector(getFeatureSP, (state: FeatureSPState) => state.searchResult)

export const selectSearchRequest = createSelector(getFeatureSP, (state: FeatureSPState) => state.searchRequest)

export const selectSPisDownloadLoading = createSelector(getFeatureSP, (state: FeatureSPState) => state.isDownloadLoading)
